import { render, staticRenderFns } from "./MyProjectContractConfirms.vue?vue&type=template&id=44b31b3a&scoped=true"
import script from "./MyProjectContractConfirms.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectContractConfirms.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectContractConfirms.vue?vue&type=style&index=0&id=44b31b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b31b3a",
  null
  
)

export default component.exports